import List, { ListProps } from '@material-ui/core/List';

export type DSListProps = ListProps & { ['data-cy']?: string };
export const DSList = List;
